import { httpClient, postProcessUpsert } from "@genai/http-client";
import { ChunkingStrategy } from "../model";

export const fetchChunkingStrategies = async (
  fileType: string,
): Promise<ChunkingStrategy[]> => {
  const formattedFileType = fileType.replaceAll('/', '_');

  return httpClient(
    `/enums/file-types/${formattedFileType}/chunking-strategies`,
  ).then(postProcessUpsert<ChunkingStrategy[]>);
};
